import {
    Directive,
    ElementRef,
    HostListener,
    Renderer2,
    Output,
    EventEmitter,
  } from '@angular/core';
  
  @Directive({
    selector: '[appCuitFormatter]',
  })
  export class CuitFormatterDirective {
    @Output() valueChange = new EventEmitter<string>();
  
    constructor(private el: ElementRef, private renderer: Renderer2) {}
  
    @HostListener('input', ['$event.target.value']) onInput(value: string) {
      const formatted = this.formatCuit(value);
      this.renderer.setProperty(this.el.nativeElement, 'value', formatted);
      this.valueChange.emit(formatted);
    }
  
    @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
      event.preventDefault();
      const pasted = event?.clipboardData?.getData('text/plain') || '';
      const formatted = this.formatCuit(pasted);
      this.renderer.setProperty(this.el.nativeElement, 'value', formatted);
      this.valueChange.emit(formatted);
    }
  
    private formatCuit(value: string): string {
      // Eliminar todo excepto números
      const numbers = value.replace(/\D/g, '').slice(0, 11); // Solo los primeros 11 dígitos
  
      const part1 = numbers.slice(0, 2);
      const part2 = numbers.slice(2, 10);
      const part3 = numbers.slice(10, 11);
  
      let result = part1;
      if (part2) result += '-' + part2;
      if (part3) result += '-' + part3;
  
      return result.toUpperCase();
    }
  }
  